<template>
    <v-container fluid>
        <v-data-table
            :headers="headers"
            :items="itemsFiltered"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            disable-pagination
            hide-default-footer
            :height="$vuetify.breakpoint.mdAndDown ? '75vh' : '66vh'"
            fixed-header
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col cols="10" class="d-flex mb-n3">
                        <h1 class="mr-4">HPL</h1>
                        <v-btn
                            rounded
                            color="primary"
                            @click="openCreateItem"
                            class="mx-2"
                        >
                            <v-icon>
                                mdi-plus
                            </v-icon>
                            {{ $vuetify.breakpoint.smAndDown ? '' : 'NEW' }}
                        </v-btn>
                    </v-col>
                    <v-spacer />
                    <v-btn
                        icon
                        x-large
                        color="primary"
                        class="ma-0 pa-0"
                        @click="openFinishes(fileName)"
                    >
                        <v-icon>
                            mdi-eye
                        </v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        x-large
                        color="primary"
                        class="ma-0 pa-0"
                        @click="dialogFile = true"
                    >
                        <v-icon>
                            mdi-import
                        </v-icon>
                    </v-btn>
                </v-row>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.name`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="searchByName"
                    dense
                    prepend-icon="mdi-filter"
                    clearable
                />
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.4x8`]="{ item }">
                <p class="py-0 my-0">
                    <v-icon
                        small
                        class="pa-2 d-flex justify-center align-center"
                        color="primary"
                        v-if="item['4x8']"
                    >
                        mdi-check
                    </v-icon>
                </p>
            </template>
            <template v-slot:[`item.4x10`]="{ item }">
                <p class="py-0 my-0">
                    <v-icon
                        small
                        class="pa-2 d-flex justify-center align-center"
                        color="primary"
                        v-if="item['4x10']"
                    >
                        mdi-check
                    </v-icon>
                </p>
            </template>
            <template v-slot:[`item.5x12`]="{ item }">
                <p class="py-0 my-0">
                    <v-icon
                        small
                        class="pa-2 d-flex justify-center align-center"
                        color="primary"
                        v-if="item['5x12']"
                    >
                        mdi-check
                    </v-icon>
                </p>
            </template>
            <template v-slot:[`item.image`]="{ item }">
                <div class="d-flex align-center flex-wrap">
                    <v-icon
                        v-if="item.image?.file"
                        :disabled="loading"
                        color="primary"
                        small
                    >
                        mdi-paperclip
                    </v-icon>
                    <span
                        v-if="item.image?.file && item.image.name"
                        role="button"
                        class="file-link"
                        :style="{ color: '#2b81d6' }"
                        @click="openImage(item.image)"
                        >{{ item.image ? item.image.name : 'File here' }}</span
                    >
                    <v-icon
                        v-if="item.image?.file"
                        :disabled="loading"
                        @click="deleteFile(item)"
                        class="ml-1"
                        color="grey darken-2"
                        small
                    >
                        mdi-close-circle
                    </v-icon>
                    <v-btn
                        v-if="!item.image?.file"
                        :disabled="loading"
                        x-small
                        @click="onButtonClick('images', item)"
                        depressed
                        fab
                        rounded
                        color="primary"
                        class="ml-10"
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <input
                        :ref="`image_${item.id}`"
                        class="d-none"
                        type="file"
                        name="images"
                        @change="onFileChanged($event, item)"
                    />
                </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex justify-center">
                    <v-btn small icon @click="openEditItem(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn small icon @click="openDeleteItem(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>
        <!--FORM-->

        <v-dialog
            v-model="openItemForm"
            :retain-focus="false"
            persistent
            width="670px"
        >
            <FinishFormHPL
                v-if="openItemForm"
                :createForm="createForm"
                :item="selectedItem"
                :originalItem="originalItem"
                :setting="setting"
                @addItem="addItem"
                @replaceItem="replaceItem"
                @close="closeEditItem"
            />
        </v-dialog>
        <v-dialog
            v-model="dialogFile"
            persistent
            max-width="600px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="dialogFile">
                <v-card-title class="text-h5">
                    <v-btn
                        small
                        icon
                        @click="closeDialog()"
                        color="primary"
                        class="ml-n3 mr-2"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    Upload Finish File
                </v-card-title>
                <v-divider class="ml-4 mr-5" />
                <v-card-text>
                    <v-form v-model="valid" class="mt-2 mb-0">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-file-input
                                    chips
                                    label="File Input"
                                    v-model="selectedFile"
                                    :rules="[rules.required]"
                                    required
                                    prepend-icon="mdi-paperclip"
                                    accept=".pdf"
                                ></v-file-input>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        rounded
                        color="primary"
                        class="mb-5 mt-n4"
                        @click="saveFile"
                        :disabled="!valid"
                        :loading="loading"
                    >
                        ADD FILE
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--Delete-->
        <v-dialog
            v-model="openDeleteWarning"
            persistent
            max-width="400px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="openDeleteWarning">
                <v-card-title class="text-h5">Delete Item</v-card-title>
                <v-card-text>
                    Are you sure you want to delete this finish?
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="secondary" @click="closeDeleteItem">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="deleteItem"
                        text
                        color="error"
                        :loading="loading"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import _ from 'lodash'
import API from '@/services/api'
import { openFile } from '@/services/storage/openFile.js'
import { saveFile } from '@/services/storage/saveFile.js'
import { deleteFile } from '@/services/storage/deleteFile.js'
import { v4 as uuidv4 } from 'uuid'
import { storage } from '@/services/firebase'

export default {
    name: 'FinishHPL',
    props: {
        setting: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        FinishFormHPL: () =>
            import('@/components/Settings/Clients/FinishFormHPL.vue'),
    },
    data: () => ({
        loading: false,
        items: [],
        selectedItem: {},
        originalItem: {},
        createForm: true,
        openItemForm: false,
        dialogFile: false,
        openDeleteWarning: false,
        valid: false,
        file: null,
        selectedFile: null,
        companyId: JSON.parse(localStorage.getItem('company')),
        folderPath: 'settings/client_portal/finishes/hplFinishes',
        fileName: 'HPL_FINISH_CATALOG.pdf',
        rules: {
            required: v => !!v || 'Required',
            value: v => !v || v.size > 0 || 'Required',
        },
        headers: [
            {
                text: 'NAME',
                value: 'name',
                sortable: false,
            },
            {
                text: 'TYPE',
                value: 'type',
                sortable: false,
            },
            {
                text: 'LEAD TIME',
                value: 'leadTime',
                width: 80,
                sortable: false,
            },
            {
                text: "4' X 8'",
                value: '4x8',
                sortable: false,
                width: 74,
                align: 'center',
            },
            {
                text: "4' X 10'",
                value: '4x10',
                sortable: false,
                width: 74,
                align: 'center',
            },
            {
                text: "5' X 12'",
                value: '5x12',
                sortable: false,
                width: 74,
                align: 'center',
            },
            {
                text: 'IMAGE',
                value: 'image',
                sortable: false,
                align: 'rigth',
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                sortable: false,
                width: 60,
                align: 'center',
            },
        ],
        searchByName: undefined,
    }),
    async mounted() {
        try {
            this.loading = true
            this.items = await API.getAllFinishHPL(this.setting.id)
        } catch (error) {
            this.setErrorItems({
                name: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    computed: {
        itemsFiltered() {
            const conditions = []
            if (this.searchByName) {
                conditions.push(this.filterByName)
            }
            let filteredItems = this.items
            if (conditions.length > 0) {
                filteredItems = this.items.filter(item => {
                    return conditions.every(condition => {
                        return condition(item)
                    })
                })
            }
            return this.sort([...filteredItems])
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        sort(items) {
            const arrayToSort = items || this.items
            return arrayToSort.sort((a, b) => {
                const aIsTBD = a.name === 'TBD'
                const bIsTBD = b.name === 'TBD'
                if (aIsTBD && !bIsTBD) return -1
                if (!aIsTBD && bIsTBD) return 1
                return a.name.localeCompare(b.name)
            })
        },
        formatNumber(number) {
            return new Intl.NumberFormat('de-DE', {
                maximumFractionDigits: 4,
            }).format(number || 0)
        },
        openLocalFile() {
            if (this.selectedFile) {
                // Create a temporal URL for the file
                const pdfUrl = URL.createObjectURL(this.selectedFile)
                // Open the file
                window.open(pdfUrl, '_blank')
            }
        },
        filterByName(item) {
            return item.name
                .toLowerCase()
                .includes(this.searchByName.toLowerCase())
        },
        replaceItem(itemToUpdate) {
            const index = this.items.findIndex(
                item => item.id == itemToUpdate.id
            )
            if (index >= 0) {
                this.items.splice(index, 1, {
                    ...this.items[index],
                    ...itemToUpdate,
                })
            }
        },
        addItem(item) {
            this.items.push(item)
            this.searchByName = ''
        },
        removeItem() {
            const index = this.items.findIndex(
                item => item.id == this.selectedItem.id
            )
            if (index >= 0) {
                this.items.splice(index, 1)
            }
        },
        closeDialog() {
            this.dialogFile = false
            this.selectedFile = null
        },
        async deleteItem() {
            try {
                this.loading = true
                await API.deleteFinishHPL({
                    settingId: this.setting.id,
                    id: this.selectedItem.id,
                })
                this.removeItem()
                this.closeDeleteItem()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async openFinishes(file) {
            try {
                this.loading = true
                await openFile(file, `${this.companyId}/${this.folderPath}`)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async saveFile() {
            try {
                this.loading = true
                await saveFile(
                    this.selectedFile,
                    `${this.companyId}/${this.folderPath}`,
                    'HPL_FINISH_CATALOG.pdf'
                )
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
                this.closeDialog()
            }
        },
        onButtonClick(type, item) {
            if (type == 'images') {
                const inputRef = this.$refs[`image_${item.id}`]
                if (inputRef) {
                    inputRef.click()
                }
            }
        },
        async onFileChanged(e, item) {
            if (e.target.files.length > 0) {
                const file = e.target.files[0]
                await this.saveImage(file, item)
                switch (e.target.name) {
                    case 'images':
                        this.$refs[`image_${item.id}`].value = ''
                        break
                    default:
                        return null
                }
            }
        },
        async saveImage(file, item) {
            try {
                this.loading = true
                const ext = file.name
                    .slice(file.name.lastIndexOf('.'))
                    .toLowerCase()
                const name = `${uuidv4()}${ext}`
                const finish = await API.updateFinishHPL({
                    settingId: this.setting.id,
                    id: item.id,
                    image: { name: file.name, file: name },
                })
                const fileRef = await storage().ref(
                    `${this.companyId}/${this.folderPath}/${name}`
                )
                await fileRef.put(file)
                const index = this.items.findIndex(i => i.id == item.id)
                this.items.splice(index, 1, { ...this.items[index], ...finish })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async openImage(image) {
            try {
                this.loading = true
                await openFile(
                    image.file,
                    `${this.companyId}/settings/client_portal/finishes/hplFinishes`
                )
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async deleteFile(item) {
            try {
                this.loading = true
                const finish = await API.updateFinishHPL({
                    settingId: this.setting.id,
                    id: item.id,
                    image: {},
                })
                await deleteFile(
                    item.image.file,
                    `${this.companyId}/settings/client_portal/finishes/hplFinishes`
                )
                const index = this.items.findIndex(i => i.id == item.id)
                this.items.splice(index, 1, { ...this.items[index], ...finish })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeDeleteItem() {
            this.selectedItem = {}
            this.openDeleteWarning = false
        },
        openDeleteItem(item) {
            this.selectedItem = _.cloneDeep(item)
            this.openDeleteWarning = true
        },
        closeEditItem() {
            this.createForm = true
            this.selectedItem = {}
            this.originalItem = {}
            this.openItemForm = false
        },
        openEditItem(item) {
            this.createForm = false
            this.selectedItem = _.cloneDeep(item)
            this.originalItem = _.cloneDeep(item)
            this.openItemForm = true
        },
        openCreateItem() {
            this.createForm = true
            this.openItemForm = true
        },
    },
}
</script>

<style>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead {
    background: #eeeeee;
    position: sticky;
    z-index: 2;
}
.v-input .v-label {
    font-size: 12px;
}
.v-data-table-header th {
    background-color: #eeeeee !important;
}
</style>
